function gap_calculator() {

    // Set the inital car width for the animation
    jQuery(function () {adjust_widths();});

    // Set the initial quote button params for each calculator
    jQuery('.gap-calculator').not('.tab-comparison').each(function() {
        var quote_btn = jQuery(this).find('.quote-me-btn');
        var quote_btn_href = quote_btn.attr('href');
        quote_btn_href = quote_btn_href + "?term=3&vehicle_value=19000";
        quote_btn.attr('href', quote_btn_href);
    });

    // Throttled resize function for the car slider animation
    var doit
    jQuery(window).on('resize', function(){
        clearTimeout(doit);
        doit = setTimeout(adjust_widths, 100);
    })

    // On value input change
    jQuery("[name='vehicle-value']").on('change', function(){

        // Store the parent container
        var parent = jQuery(this).closest('.gap-calculator');

        // Vehicle value
        var value = jQuery(this).val();

        // Strip the commas (thousand separators) if there are any
        value = value.replace(',', '');

        // Check if the value is empty
        if (value === '') {
            value = '0';
        }

        // Set the value of the input field with commas (localeString)
        jQuery(this).val(parseFloat(value))

        // Get the term
        var term = parent.find("input[name^='calc-term']:checked").val()

        // Get the calculation multiplier
        var multiplier = parent.find("input[name^='calc-term']:checked").data('multiplier')

        // Do the calculation
        var result = doCalc(parseFloat(value), parseInt(term), parseFloat(multiplier))
        
        parent.find('.result-amount').text('£'+result.benefit)
        parent.find('.difference-amount').text('£'+result.shortfall)
        updateDynamicCopy(parent, term, multiplier)

        // Set the car width based on result percentage (for the slide animation)
        parent.find('.withoutcar').css('width', result.percentage+'%')

        // Set GET params on the quote me button
        var quote_btn = parent.find('.quote-me-btn')
        var quote_btn_href = quote_btn.attr('href').split('?')[0]
        quote_btn_href = quote_btn_href + "?term=" + term + "&vehicle_value=" + value
        quote_btn.attr('href', quote_btn_href)
    })

    jQuery("input[name^='calc-term']").on('change', function(){
        // Get the parent container (for DOM traversals)
        var parent = jQuery(this).closest('.gap-calculator')

        // Get the term length
        var term = jQuery(this).val()

        // Get the multipllier for the calculation
        var multiplier = parent.find("input[name^='calc-term']:checked").data('multiplier')

        // Get the vehicle value
        var value = parent.find("[name='vehicle-value']").val()
        value = value.replace(',','')

        // Do the calculation
        var result = doCalc(parseFloat(value), parseInt(term), parseFloat(multiplier))

        // Set the results in the HTML
    
        if (value === '') {
            parent.find('.result-amount').text('£0')
            parent.find('.difference-amount').text('£0')
            updateDynamicCopy(parent, term, multiplier)
            return;
        }
        
        parent.find('.result-amount').text('£'+result.benefit)
        parent.find('.difference-amount').text('£'+result.shortfall)
        updateDynamicCopy(parent, term, multiplier)

        // Set the car width for the slide animation thing
        parent.find('.withoutcar').css('width', result.percentage+'%')

        // Set the quote button GET params
        var quote_btn = parent.find('.quote-me-btn')
        var quote_btn_href = quote_btn.attr('href').split('?')[0]
        quote_btn_href = quote_btn_href + "?term=" + term + "&vehicle_value=" + value
        quote_btn.attr('href', quote_btn_href)
    })

    // Force numeric only input for the text box
    jQuery('body').on('propertychange input', "[name='vehicle-value']", forceNumeric);

    // Prevent form submission on Enter key unless submit button is focused
    jQuery('.gap-calculator').on('keydown', 'form', function(e) {
        // If Enter key is pressed
        if (e.key === 'Enter' || e.keyCode === 13) {
            // Check if the submit button is focused
            var submitButton = jQuery(this).closest('.gap-calculator').find('.quote-me-btn');
            var isSubmitFocused = document.activeElement === submitButton[0];
            
            // Only prevent default if submit button is NOT focused
            if (!isSubmitFocused) {
                e.preventDefault();
                return false;
            }
        }
    });

    // Also prevent Enter key on the input field itself
    jQuery('.gap-calculator').on('keydown', "[name='vehicle-value']", function(e) {
        if (e.key === 'Enter' || e.keyCode === 13) {
            e.preventDefault();
            // Trigger the change event to update calculations
            jQuery(this).trigger('change');
            return false;
        }
    });

    jQuery('.gap-calculator').on('click', '#submit-quote', function(e) {
        e.preventDefault();
        var calculator = jQuery(this).closest('.gap-calculator');
        submitQuote(calculator);
    });

}

function updateDynamicCopy(parent, term, multiplier) {
    var percent = Math.round(parseFloat(multiplier) * 100) + '%'
    parent.find('.calc-dynamic-percent').text(percent)
    parent.find('.calc-dynamic-years').text(term)
}

function submitQuote(calculator){
    var URL = 'https://www.ala.co.uk/quote/infographic-action?ajax=1';
    var data = {
        "action":"quoteme",
        "product_code": calculator.find('.prod-code').val(),
        "vehicle_value": calculator.find('.vehicle-value-input').val(),
        "term": calculator.find("input[name^='calc-term']:checked").val(),
        "ajax":1
    };


    $.ajax({
        type: "POST",
        url: URL,
        dataType:"json",
        data:data,
        success: function(response){
        //    console.log(response);

           if(typeof response.url !== 'undefined'){
            window.location.href = response.url;
           }
        },
        error: function (xhr, ajaxOptions, thrownError) {
            // console.log(xhr.responseText);
            console.log(thrownError);
          }
      });

}

// Fix car width on resize for the slide animation
function adjust_widths() {
    jQuery('.gap-calculator').each(function() {
        var car_width = jQuery(this).find('.calculator--car-image').width();
        jQuery(this).find('.v-without').css('width', car_width);
        jQuery(this).find('.calculator--car-image').css('width', car_width);
    });
}


// Return GAP calculations
function doCalc(value, term, multiplier) {
    // console.log(value, term, multiplier)
    var benefit = Math.round(value * multiplier)
    var shortfall = Math.round(value - benefit) 
    var percentage = benefit/value * 100

    var result = {
        shortfall: shortfall.toLocaleString(),
        benefit: benefit.toLocaleString(),
        percentage: percentage
    }

    return result;
}

// Force numeric keyboard input for the vehicle value box
function forceNumeric(){
    var $input = jQuery(this);
    $input.val($input.val().replace(/[^\d]+/g,''));
}

export default gap_calculator
